import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const NoTitular: FC = () => {
  return <>{SystemManager.getSystem('sin-tarjeta')}</>;
};

export default NoTitular;
